import { CustomerProps, OrganizationType } from '../types';

export enum BeneficiaryStatus {
  DRAFT = 'DRAFT',
  UNDER_REVIEW = 'UNDER_REVIEW',
  REJECTED = 'REJECTED',
  APPROVED = 'APPROVED',
}

export interface Beneficiary {
  address: string;
  aba?: string;
  bankAccountNumber: null;
  bankAddress: string;
  bankCountry: string;
  bankName: string;
  collectorContact?: string;
  beneficiaryType: OrganizationType;
  bic: string;
  city: string;
  correspondentAccount: string;
  country: {
    name: string;
  };
  countryId: string;
  currency: {
    name: string;
  };
  currencyId: string;
  iban: string;
  id: string;
  intermediaryBankAddress: string;
  intermediaryBankBIC: string;
  intermediaryBankCorrespondentAccount: string;
  intermediaryBankCountry: string;
  intermediaryBankName: string;
  name: string;
  nickname: string;
  organizationId: string;
  organization?: CustomerProps;
  paymentType: string;
  phone: string;
  postCode: string;
  sortCode: string;
  status: BeneficiaryStatus;
  useIntermediaryBank: boolean;
  countContracts: {
    count: number;
  };
  documents?: {
    edges: {
      node: {
        id: string;
        documentCategoryId: string;
        name: string;
        uploadId: string;
      };
    }[];
  };
  render?: Record<string, React.JSX.Element>;
}

export interface BeneficiaryStatusLogs {
  id: string;
  beneficiaryId: string;
  createdAt: string;
  deletedAt: string;
  diff: {
    next: {
      status: BeneficiaryStatus;
      updatedAt: string;
    };
    prev: {
      status: BeneficiaryStatus;
      updatedAt: string;
    };
  };
  updatedAt: string;
  updatedByEmployee: {
    profile: {
      firstName: string;
      lastName: string;
    };
  };
}

export interface ContractStatement {
  id: string;
  createdAt: string;
  currencyId: string;
  currency: {
    name: string;
    decimals: number;
  };
  sum: number;
  creditSum: number;
  debitSum: number;
  generalLedgerTransaction?: {
    creditAccountNumber: string;
    debitAccountNumber: string;
  };
  type: string;
  transactionId: string;
  operationType: string;
  render?: Record<string, React.JSX.Element>;
}

export interface BeneficiaryContract {
  beneficiaryId: string;
  createdAt: string;
  deletedAt: string;
  currencyId?: string;
  id: string;
  name: string;
  updatedAt: string;
  sum?: number;
  description?: string;
  status: string;
  transactionsSum?: number;
  statementItems?: {
    edges: {
      node: ContractStatement;
    }[];
  };
  supportingDocuments?: {
    edges: {
      node: {
        id: string;
        uploadId: string;
        createdAt: string;
        name?: string;
      };
    }[];
  };
  render?: Record<string, React.JSX.Element>;
}

export interface BeneficiaryContractFormValues {
  id: string;
  name: string;
  currencyId?: string;
  description?: string;
  sum?: number;
  status?: string;
  uploadId?: string[];
}
